export default __webpack_public_path__ + "static/media/delete.1f25364c.svg";